import { useMutation } from 'react-query';
import useAuthApi from '../../Utils/Api/useAuthApi';

export default function useResendEmailConfirmation() {
  const api = useAuthApi();

  return useMutation(() => api.resendEmailConfirmation());
}
